import { useMutation } from "@apollo/client/react";
import { VALIDATE_INVOICE } from "../../mutations/invoices/validateInvoice";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";

export const useValidateInvoice = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [validateInvoice, { data, loading, error }] = useMutation(
    VALIDATE_INVOICE,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: noRefetch ? [] : [GET_INVOICE_LATEST_VALIDATION_RESULT],
      awaitRefetchQueries: true,
    },
  );

  return { validateInvoice, data, loading, error };
};
